import { action } from 'typesafe-actions';
import {
  UserManagementActionTypes,
  UserInfo,
  AcceptUser,
  VerifyUserSubmission,
} from './types';
import { RolePatch } from '../../pages/profile/useUserProfileReducer';

export const userSelected = (user: UserInfo) => action(UserManagementActionTypes.SELECTED, user);
export const updateUserRequest = (
  id: string,
  patch: any,
  verifyUserSubmission?: VerifyUserSubmission
) =>
  action(UserManagementActionTypes.UPDATE_USER_REQUEST, {
    id: id,
    data: patch,
    verifyUserSubmission: verifyUserSubmission,
  });
export const updateUserSuccess = (data: UserInfo) =>
  action(UserManagementActionTypes.UPDATE_USER_SUCCESS, data);
export const updateUserError = (message: string) =>
  action(UserManagementActionTypes.UPDATE_USER_ERROR, message);
export const acceptUserRequest = (request: AcceptUser) =>
  action(UserManagementActionTypes.ACCEPT_USER_REQUEST, request);
export const acceptUserSuccess = (id: string) =>
  action(UserManagementActionTypes.ACCEPT_USER_SUCCESS, id);
export const updateUserRolesRequest = (
  id: string,
  rolePatch: RolePatch,
) =>
  action(UserManagementActionTypes.UPDATE_USERROLES_REQUEST, {
    id: id,
    rolePatch: rolePatch,
  });
export const updateUserRolesSuccess = (data: UserInfo) =>
  action(UserManagementActionTypes.UPDATE_USERROLES_SUCCESS, data);
export const updateUserRolesError = (message: string) =>
  action(UserManagementActionTypes.UPDATE_USERROLES_ERROR, message);
export const acceptUserError = (message: string) =>
  action(UserManagementActionTypes.ACCEPT_USER_ERROR, message);